
// whiteLabel产品计价类型
export enum WhiteLabelPriceTypeEnum {
    // 离散型
    DISCRETE = "Discrete",
    // 区间型
    INTERVAL = "Interval"
}